import React from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const products = [
  { name: "Shrava360", logo: "/img/74.png", href: "/hrms", tag: "Human Resource Management System" },
  { name: "Lauratek", logo: "/img/111.png", href: "/lauratek-lms", tag: "Learning Management System" },
  { name: "Logsphere", logo: "/img/85.png", href: "/kpi", tag: "Workforce Monitoring System" },
  { name: "Rob n Grab", logo: "/img/93.png", href: "/rob", tag: "Recruitment & Onboarding" },
  { name: "ONESTEP", logo: "/img/103.png", href: "/onestepmedi", tag: "All-in-One Healthcare System" },
  { name: "Lauratek v2.0", logo: "/img/48.png", href: "/lms2", tag: "Learning Management System" },
  { name: "Devtalent", logo: "/img/37.png", href: "/devtalnet", tag: "Talent Evaluation Platform" },
  { name: "Hisphere", logo: "/img/213.png", href: "/hisphare", tag: "Recruitment & Onboarding" },
  { name: "Vishan", logo: "/img/63.png", href: "/sams", tag: "School Management System" },
  { name: "Arogya Narayan", logo: "/img/53.png", href: "/hms", tag: "Hospital Management System" },
];

const Products = () => {
  return (
    <section className="relative py-14 sm:py-10 bg-gradient-to-b from-gray-50/60 to-white text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Heading */}
        <div className="text-center mb-8 sm:mb-10">
          <div className="inline-flex items-center gap-2 mb-2">
            <span className="relative inline-flex">
              <span className="w-5 h-5 rounded-full border-2 border-blue-500" />
              <span className="absolute -bottom-1 -right-1 w-2 h-2 rounded-full bg-blue-500" />
            </span>
            <h2 className="text-2xl sm:text-3xl font-extrabold text-gray-800">
              Our <span className="text-gray-900">Products</span>
            </h2>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 items-stretch">

          {products.map((p) => (
            <motion.a
              key={p.name}
              href={p.href}
              whileHover={{ y: -4 }}
              transition={{ type: "spring", stiffness: 300, damping: 20 }}
              className="group h-full min-h-[240px] no-underline rounded-[22px] border border-gray-200/70
                         bg-gradient-to-b from-white to-gray-50
                         shadow-[0_6px_20px_rgba(0,0,0,0.06)]
                         hover:shadow-[0_12px_26px_rgba(37,99,235,0.12)]
                         px-6 sm:px-8 py-6
                         flex flex-col items-center justify-between text-center gap-3 relative"
            >

              <img
                src={p.logo}
                alt={p.name}
                className="h-14 sm:h-16 w-auto object-contain mt-2"
                loading="lazy"
              />

              <span className="text-lg sm:text-xl font-semibold text-gray-800">
                {p.name}
              </span>

              {/* TAG AT BOTTOM – NO BG, JUST TEXT */}
              <span className="text-xs font-medium text-black mt-2 mb-1">
                {p.tag}
              </span>

            </motion.a>
          ))}

        </div>

      </div>
    </section>
  );
};

export default Products;
